export const getPadding = name => ({ theme: { padding } }) => padding[name]
export const getColor = name => ({ theme: { color } }) => color[name]
